var map = {
	"./american-express.png": 1017,
	"./discover.png": 1018,
	"./jcb.png": 1019,
	"./mastercard.png": 1020,
	"./savvas-logo.jpg": 1021,
	"./visa.png": 1022,
	"./wr-favicon-white.png": 300,
	"./wr-logo-white.png": 138,
	"./wr-logo.png": 301
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	return map[req] || (function() { throw new Error("Cannot find module '" + req + "'.") }());
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 366;



//////////////////
// WEBPACK FOOTER
// ./assets/images/logos .\.jpg*|.\.png*
// module id = 366
// module chunks = 0